import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(({ breakpoints }: Theme) => ({
  root: {
    margin: 0,
    fontSize: 14,
  },
  [breakpoints.down(426)]: {
    root: {
      marginLeft: 0,
    },
  },
}));
